/* TinyOops DC runtime — replaces the prototype's support.js.
   Bindings: data-dc-click, data-dc-input, data-dc-text, data-dc-if (on <sc-if>), data-dc-style, data-dc-value.
   Components register themselves on window.__tinyoopsDC as [name, factory(DCLogic)].
   v3 (31.8.2026): adds reveal-on-scroll for below-the-fold sections and pauses marquees while off-screen. */
(function () {
  'use strict';

  class DCLogic {
    constructor(root, props) {
      this.root = root;
      this.props = props || {};
    }
    setState(patch) {
      var p = typeof patch === 'function' ? patch(this.state) : patch;
      this.state = Object.assign({}, this.state, p);
      this.render();
    }
    call(name, e) {
      var fn = this.renderVals()[name];
      if (typeof fn === 'function') fn(e);
    }
    mount() {
      var self = this;
      this.state = this.state || {};
      this.root.querySelectorAll('[data-dc-click]').forEach(function (el) {
        el.addEventListener('click', function (e) { self.call(el.getAttribute('data-dc-click'), e); });
      });
      this.root.querySelectorAll('[data-dc-input]').forEach(function (el) {
        el.addEventListener('input', function (e) { self.call(el.getAttribute('data-dc-input'), e); });
      });
      this.render();
      if (typeof this.componentDidMount === 'function') this.componentDidMount();
      window.addEventListener('pagehide', function () {
        if (typeof self.componentWillUnmount === 'function') self.componentWillUnmount();
      });
    }
    render() {
      var v = this.renderVals();
      this.root.querySelectorAll('[data-dc-text]').forEach(function (el) {
        var val = v[el.getAttribute('data-dc-text')];
        var s = val == null ? '' : String(val);
        if (el.textContent !== s) el.textContent = s;
      });
      this.root.querySelectorAll('[data-dc-if]').forEach(function (el) {
        if (v[el.getAttribute('data-dc-if')]) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
      });
      this.root.querySelectorAll('[data-dc-style]').forEach(function (el) {
        el.getAttribute('data-dc-style').split(';').forEach(function (pair) {
          var i = pair.indexOf('=');
          if (i < 1) return;
          var prop = pair.slice(0, i), key = pair.slice(i + 1);
          el.style.setProperty(prop, String(v[key]));
        });
      });
      this.root.querySelectorAll('[data-dc-value]').forEach(function (el) {
        var val = v[el.getAttribute('data-dc-value')];
        var s = val == null ? '' : String(val);
        if (el.value !== s) el.value = s;
      });
    }
  }

  function boot() {
    var registry = {};
    (window.__tinyoopsDC || []).forEach(function (entry) { registry[entry[0]] = entry[1]; });
    window.__tinyoopsDC = { push: function (entry) { registry[entry[0]] = entry[1]; mountRoots(); } };

    function mountRoots() {
      document.querySelectorAll('[data-dc-root]').forEach(function (root) {
        if (root.__dcMounted) return;
        var factory = registry[root.getAttribute('data-dc-root')];
        if (!factory) return;
        var props = {};
        try { props = JSON.parse(root.getAttribute('data-dc-props') || '{}'); } catch (e) { console.error('TinyOops: bad data-dc-props', e); }
        root.__dcMounted = true;
        var Component = factory(DCLogic);
        try { new Component(root, props).mount(); } catch (e) { console.error('TinyOops: component failed', e); }
      });
    }
    mountRoots();

    // Mobile menu: close on outside click / Escape
    document.addEventListener('click', function (e) {
      var open = document.querySelectorAll('details.mnav[open]');
      if (!open.length) return;
      var inside = e.target.closest('details.mnav');
      if (!inside || e.target.closest('a')) open.forEach(function (d) { d.removeAttribute('open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('details.mnav[open]').forEach(function (d) { d.removeAttribute('open'); });
    });

    // Reveal-on-scroll (compositor-only: opacity + transform) and marquees that only run while visible
    try {
      if ('IntersectionObserver' in window) {
        var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        var vh = window.innerHeight;
        if (!reduce) {
          var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
          document.querySelectorAll('section, [data-rv]').forEach(function (s) {
            if (s.getBoundingClientRect().top > vh * 0.85) { s.classList.add('rv'); io.observe(s); }
          });
        }
        var mq = [].filter.call(document.querySelectorAll('[style*="animation"]'), function (el) {
          return getComputedStyle(el).animationName.split(',').some(function (n) { return n.trim() === 'mq'; });
        });
        if (mq.length) {
          var mo = new IntersectionObserver(function (es) { es.forEach(function (en) { en.target.style.animationPlayState = en.isIntersecting ? 'running' : 'paused'; }); });
          mq.forEach(function (m) { mo.observe(m); });
        }
      }
    } catch (err) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
